import React from 'react';

export const PilotPhaseSection = () => {
  const focusPoints = [
    {
      title: 'Controlled Rollout',
      description: 'Starting in Austria and Jordan, we deploy in measured steps so every detail is right.'
    },
    {
      title: 'Real-World Validation',
      description: 'We are pressure-testing onboarding, support, and the merchant experience with early users.'
    },
    {
      title: 'Operational Readiness',
      description: 'Our team is refining workflows and tooling before opening up to a broader network.'
    }
  ];

  return (
    <section className="section-padding bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-[#10B981]/10 text-[#10B981] rounded-full text-sm font-semibold tracking-wide mb-6">
            Pilot Phase
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Building <span className="gradient-text">deliberately</span>
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto">
            Syrveo is in its pilot phase. Rather than rushing, we are preparing the market carefully — validating product fit, refining the onboarding journey, and laying the operational groundwork for sustainable growth across Europe and the Middle East.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mt-12">
          {focusPoints.map((point, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-2xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <h3 className="text-lg font-bold text-gray-900 mb-3">{point.title}</h3>
              <p className="text-gray-600 leading-relaxed">{point.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PilotPhaseSection;
